export const BUS_COMPANIES = {
	PLANALTO: 'PLANALTO',
	JCA: 'JCA',
	UNESUL: 'UNESUL',
}
